export const MICROCREDITS_AMOUNT_MIN = 1000;
export const MICROCREDITS_TERM_MIN = 7;
